const state = {
    jobcards: [],
    jobcardsFiles: [],
    jobcardsFile: [],
    jobId: {},
    signature: [],
    signatureid: [],
    jobDemand: [],
    jobFile: {},
    loading: false,
    JobcardPriority: [],
};

export default state;